var activeCardsCategory = null;

document.addEventListener("DOMContentLoaded", function () {
  var option1Elements = document.querySelectorAll(".option-1");
  var option2Elements = document.querySelectorAll(".option-2");
  var option1Inputs = document.querySelectorAll(".options-wrapper .option-1-input");
  var option2Inputs = document.querySelectorAll(".options-wrapper .option-2-input");

  function handleInputChange(optionInputs, optionElements, checkedInput) {
    document.querySelectorAll(".quiz-modal-product-grid li.checked-card").forEach((card) => {
      card.classList.remove("checked-card");
    });

    let activeSlide = document.querySelector(".active-quiz");

    if (activeSlide.classList.contains("disable-next")) {
      activeSlide.classList.remove("disable-next");
    }

    const value = checkedInput.getAttribute("value");

    const activeGrid =
      value === `Mens` || value === `Men's` ? "Mens" : value === `Womens` || value === `Women's` ? "Womens" : null;

    if (activeGrid !== null && activeGrid == `Mens`) {
      document.querySelector("#product-grid-for-women").setAttribute("active-grid", null);
      document.querySelector("#product-grid").setAttribute("active-grid", activeGrid);
      activeCardsCategory = activeGrid;
    } else if (activeGrid !== null && activeGrid == `Womens`) {
      document.querySelector("#product-grid").setAttribute("active-grid", null);
      document.querySelector("#product-grid-for-women").setAttribute("active-grid", activeGrid);
      activeCardsCategory = activeGrid;
    }

    if (checkedInput.checked) {
      if (
        checkedInput.parentElement.nextElementSibling &&
        checkedInput.parentElement.nextElementSibling.classList.contains("active")
      ) {
        checkedInput.parentElement.nextElementSibling.classList.remove("active");
        checkedInput.parentElement.nextElementSibling.querySelector("input").checked = false;
      }
      if (
        checkedInput.parentElement.previousElementSibling &&
        checkedInput.parentElement.previousElementSibling.classList.contains("active")
      ) {
        checkedInput.parentElement.previousElementSibling.classList.remove("active");
        checkedInput.parentElement.previousElementSibling.querySelector("input").checked = false;
      }

      checkedInput.parentElement.classList.add("active");
    }
    if (checkedInput.checked == false) {
      checkedInput.parentElement.classList.remove("active");
    }
  }

  option1Inputs.forEach(function (input) {
    input.addEventListener("change", function (event) {
      event.stopPropagation();
      handleInputChange(option1Inputs, option1Elements, this);
    });
  });

  option2Inputs.forEach(function (input) {
    input.addEventListener("change", function (event) {
      event.stopPropagation();
      handleInputChange(option2Inputs, option2Elements, this);
    });
  });
});

let activeSlide = document.querySelector(".quiz-modal-inner.active-quiz");

function removeClasses(elements, className) {
  elements.forEach((element) => {
    element.classList.remove(className);
  });
}

function addClasses(elements, className) {
  elements.forEach((element) => {
    element.classList.add(className);
  });
}

function handleProductGridVisibility() {
  if (activeCardsCategory == "Mens" || activeCardsCategory == `Men's`) {
    const productGrid = document.querySelector("#product-grid");
    const productGridWomen = document.querySelector("#product-grid-for-women");
    const quizModal = document.querySelector(".custom-style-quiz-modal");

    productGrid.style.display = "flex";
    productGridWomen.style.display = "none";

    if (!productGrid.classList.contains("active-product-grid")) {
      productGrid.classList.add("active-product-grid");
      quizModal.classList.add("active-quiz-modal");
      document.querySelector("body").classList.add("quiz-modal-active-for-body");
    }

    document.querySelector("#quiz-modal-close").addEventListener("click", function () {
      productGrid.classList.remove("active-product-grid");
      quizModal.classList.remove("active-quiz-modal");
      document.querySelector("body").classList.remove("quiz-modal-active-for-body");
    });
  } else if (activeCardsCategory == "Womens" || activeCardsCategory == `Women's`) {
    const productGrid = document.querySelector("#product-grid");
    const productGridWomen = document.querySelector("#product-grid-for-women");
    const quizModal = document.querySelector(".custom-style-quiz-modal");

    productGrid.style.display = "none";
    productGridWomen.style.display = "flex";

    if (!productGrid.classList.contains("active-product-grid")) {
      productGridWomen.classList.add("active-product-grid");
      quizModal.classList.add("active-quiz-modal");
      document.querySelector("body").classList.add("quiz-modal-active-for-body");
    }

    document.querySelector("#quiz-modal-close-for-women").addEventListener("click", function (event) {
      productGridWomen.classList.remove("active-product-grid");
      quizModal.classList.remove("active-quiz-modal");
      document.querySelector("body").classList.remove("quiz-modal-active-for-body");

      event.stopPropagation();
    });
  }
}

function processOptionInputs(activeSlide, optionSelector, optionInputSelector) {
  const optionInputs = activeSlide.querySelectorAll(`${optionSelector} ${optionInputSelector}`);

  const optionElements = activeSlide.querySelectorAll(`${optionSelector}.active`);

  const checkedOptionElements = [];

  activeSlide.classList.add("disable-next");

  optionInputs.forEach(function (input, index) {
    if (input.checked) {
      checkedOptionElements.push(optionElements[index]);
    }
  });

  let productCards = document.querySelectorAll("#product-grid li");
  let productCardsWomen = document.querySelectorAll("#product-grid-for-women li");

  checkedOptionElements.forEach(function (checkedElement) {
    productCards.forEach((card) => {
      if (card.getAttribute("data-card") == checkedElement.querySelector("input").getAttribute("data-card")) {
        card.classList.add("checked-card");
        handleProductGridVisibility();
      }
    });
    productCardsWomen.forEach((card) => {
      if (card.getAttribute("data-card") == checkedElement.querySelector("input").getAttribute("data-card")) {
        card.classList.add("checked-card");
        handleProductGridVisibility();
      }
    });
  });
}

function nextSlide() {
  const activeSlide = document.querySelector(".active-quiz");
  const activeNext = activeSlide.nextElementSibling;

  if (activeNext) {
    const isQuizModalInner = activeSlide.classList.contains("quiz-modal-inner");
    const hasNoForbiddenClass = ![
      "2A",
      "2B",
      "subquiz-sub-child",
      "subquiz-child",
      "subquiz-parent",
      "Slide-3-2A",
      "Slide-4-2A"
    ].some((cls) => activeSlide.classList.contains(cls));
    if (isQuizModalInner && hasNoForbiddenClass) {
      const optionA = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-1");
      const optionB = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-2");

      if (optionA) {
        processOptionInputs(activeSlide, ".options-wrapper .active.option-1", ".option-1-input");
        activeSlide.classList.remove("active-quiz");
        activeNext.classList.add("active-quiz");
      } else if (optionB) {
        processOptionInputs(activeSlide, ".options-wrapper .active.option-2", ".option-2-input");
        activeSlide.classList.remove("active-quiz");
        activeNext.classList.add("active-quiz");
      }
    } else if (
      activeSlide.classList.contains("2A") &&
      activeSlide.classList.contains("subquiz-parent") &&
      activeSlide.classList.contains("active-quiz")
    ) {
      const optionA = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-1");
      const optionB = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-2");
      if (optionA) {
        activeNext.classList.add("active-quiz");
        activeSlide.classList.remove("active-quiz");
      }

      if (optionB) {
        activeSlide.classList.remove("active-quiz");
        document.querySelector(".twoB").classList.add("active-quiz");
      }
    } else if (
      activeSlide.classList.contains("2A") &&
      activeSlide.classList.contains("subquiz-child") &&
      activeSlide.classList.contains("active-quiz")
    ) {
      const optionA = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-1");
      const optionB = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-2");

      if (optionA) {
        processOptionInputs(activeSlide, ".options-wrapper .active.option-1", ".option-1-input");
      }
      if (optionB) {
        activeSlide.classList.remove("active-quiz");
        activeNext.classList.add("active-quiz");
      }
    } else if (
      activeSlide.classList.contains("Slide-3-2A") &&
      activeSlide.classList.contains("subquiz-sub-child") &&
      activeSlide.classList.contains("active-quiz")
    ) {
      const optionA = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-1");
      const optionB = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-2");
      if (optionA) {
        processOptionInputs(activeSlide, ".options-wrapper .active.option-1", ".option-1-input");
      }
      if (optionB) {
        activeSlide.classList.remove("active-quiz");
        activeNext.classList.add("active-quiz");
      }
    } else if (
      activeSlide.classList.contains("Slide-4-2A") &&
      activeSlide.classList.contains("subquiz-sub-child") &&
      activeSlide.classList.contains("active-quiz")
    ) {
      const optionA = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-1");
      const optionB = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-2");
      if (optionA) {
        processOptionInputs(activeSlide, ".options-wrapper .active.option-1", ".option-1-input");
      }
      if (optionB) {
        processOptionInputs(activeSlide, ".options-wrapper .active.option-2", ".option-2-input");
      }
    }
  } else if (!activeNext && activeSlide) {
    const optionA = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-1");
    const optionB = activeSlide.querySelector(".options-wrapper .active").classList.contains("option-2");

    if (optionA) {
      processOptionInputs(activeSlide, ".options-wrapper .active.option-1", ".option-1-input");
    }

    if (optionB) {
      processOptionInputs(activeSlide, ".options-wrapper .active.option-2", ".option-2-input");
    }
  }
}

function enableNextClass(element) {
  if (element.classList.contains("disable-next")) {
    element.classList.remove("disable-next");
  }
}

function setPreviousSlide(activeSlide, activePrev) {
  activeSlide.classList.remove("active-quiz");
  activePrev.classList.add("active-quiz");
  return activePrev;
}

function previousSlide() {
  let activeSlide = document.querySelector(".active-quiz");
  let activePrev = activeSlide.previousElementSibling;

  while (activePrev) {
    if (activeSlide.classList.contains("subquiz-child") && activePrev.classList.contains("subquiz-parent")) {
      activeSlide = setPreviousSlide(activeSlide, activePrev);
      break;
    } else if (!activeSlide.classList.contains("subquiz-child") && activePrev.classList.contains("subquiz-child")) {
      const checkedInput = activePrev.querySelector("input:checked");
      if (checkedInput) {
        activeSlide = setPreviousSlide(activeSlide, activePrev);
        break;
      }
    } else if (!activeSlide.classList.contains("subquiz-child")) {
      activeSlide = setPreviousSlide(activeSlide, activePrev);
      break;
    }

    activePrev = activePrev.previousElementSibling;
  }

  enableNextClass(activeSlide);
}

function nextSlideChangePrevention() {
  let rollBackActiveSlide = document.querySelector(".active-quiz");
  let newActiveSlide = rollBackActiveSlide.previousElementSibling;
  if (rollBackActiveSlide.nextElementSibling) {
    newActiveSlide.classList.add("active-quiz");
    newActiveSlide.classList.remove("disable-next");
    rollBackActiveSlide.classList.remove("active-quiz");
  }
}

document.querySelectorAll(".quiz-modal-inner .btn-next").forEach(function (button) {
  button.addEventListener("click", function (event) {
    event.stopPropagation();
    nextSlide();
  });
});

document.querySelectorAll(".quiz-modal-inner .btn-prev").forEach(function (button) {
  button.addEventListener("click", function (event) {
    event.stopPropagation();
    previousSlide();
  });
});

if (/iPad|iPhone|iPod/.test(navigator.platform) && !window.MSStream) {
  document.documentElement.classList.add("ios");
}

document.querySelectorAll(".option-1").forEach((option) => {
  enableClickOnInputForOption(option);
});

document.querySelectorAll(".option-2").forEach((option) => {
  enableClickOnInputForOption(option);
});

function enableClickOnInputForOption(option) {
  option.addEventListener("click", function (event) {
    if (!event.target.matches("label, input")) {
      this.querySelector("input").click();
    }
  });
}
